const initialState = {
  currentStep: 0
};

export default function reducer(state=initialState, action) {
  const distance = action.payload || 1;
  switch(action.type) {
    case 'NEXT':
      return {...state, currentStep: state.currentStep + distance};
    case 'BACK':
      return {...state, currentStep: state.currentStep - distance};
    default:
      return {...state}
  }
}


// WEBPACK FOOTER //
// ./src/reducers/switcher.js